import { Input } from '../input';
import { ErrorMessage } from '../../../insfrastructure/utils/form-validators';
import birthdateIcon from '../../../assets/icons/birthdate.png';

interface DateOfBirthFieldProps {
  name?: string;
  label?: string;
  value?: any;
  onChange?: (value: any) => void;
  required?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  errors?: string[];
  placeholder?: string;
}

/**
 * Componente reutilizável para campo de data de nascimento usando InputMask
 * Baseado na implementação do Cadastro do Gestor da Empresa
 * 
 * @example
 * <DateOfBirthField
 *   value={form.date_of_birth}
 *   onChange={e => setForm({ ...form, date_of_birth: e })}
 *   errors={errors.date_of_birth}
 *   required={true}
 * />
 */
export const DateOfBirthField = ({
  name = 'date_of_birth',
  label = 'Data de Nascimento',
  value,
  onChange,
  required = false,
  readonly = false,
  disabled = false,
  errors = [],
  placeholder = 'DD/MM/AAAA'
}: DateOfBirthFieldProps) => {
  return (
    <>
      <Input
        name={name}
        label={label}
        icon={birthdateIcon}
        mask='99/99/9999'
        placeholder={placeholder}
        required={required}
        readonly={readonly}
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
      {errors && errors.length > 0 && <ErrorMessage errors={errors} />}
    </>
  );
};
